module.exports = {"320413001":"西城街道","320413100":"金城镇","320413104":"儒林镇","320413106":"直溪镇","320413108":"朱林镇","320413109":"薛埠镇","320413112":"指前镇","320413400":"经济开发区","320413401":"茅山旅游度假区","320413402":"华罗庚高新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320413.json
// module id = 961
// module chunks = 0